module.exports = __webpack_public_path__ + "img/close.6b3476d2.svg";